import { useCallback } from 'react'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { JobPosting_Job$key } from '__generated__/JobPosting_Job.graphql'
import JobFormWrapper from './components/JobFormWrapper'
import JobPostingContent from './components/JobPostingContent'

interface IJobPostingProps {
  jobFragmentRef?: JobPosting_Job$key
  editable?: boolean
  noCompany?: boolean
  hideTutorialBubble?: boolean
}

// TODO: separate this component into an editable and readonly version to avoid loading data for both
const JobPosting = ({ jobFragmentRef, editable, noCompany, hideTutorialBubble }: IJobPostingProps) => {
  const handleKeyEvent = useCallback((e: any) => {
    if (e.which === 13 && !e.shiftKey) {
      if (e.target?.tagName !== 'TEXTAREA') {
        const d = document as any
        d.activeElement?.blur()
        e.preventDefault()
      }

      e.stopPropagation()
    }
  }, [])

  const job = useFragment(graphql`
    fragment JobPosting_Job on Job {
      ...JobPostingContent_Job
      ...JobFormWrapper_Job

      incognito
    }
  `, jobFragmentRef)

  const content = (
    <JobPostingContent
      jobFragmentRef={job}
      editable={editable}
      noCompany={noCompany || job?.incognito}
      hideTutorialBubble={hideTutorialBubble}
    />
  )

  if (editable) {
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div onKeyDown={handleKeyEvent} onKeyPress={handleKeyEvent}>
        {content}
      </div>
    )
  }

  if (job) {
    return (
      <JobFormWrapper jobFragmentRef={job}>
        {content}
      </JobFormWrapper>
    )
  }

  // assume parent <form> will provide data context
  return content
}

export default JobPosting
